import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { toAdsGroupsList } from "../../../../utils/adsGroupsList";
import { AdGroupSelectionGate } from "../../../../pages/NewAdsCampaign/components/AdsCampaignSelectionGate";
import { useRequiredAdGroupSelection } from "../../../../pages/NewAdsCampaign/hooks/requiredAdsCampaignSelection";
import {
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVES_WITH_PLACEMENT_SELECTOR_TIKTOK,
  ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_TIKTOK,
  ADS_CAMPAIGN_SEARCH_SEGMENTATION_BEHAVIORS_TYPE,
  ADS_CAMPAIGN_SEARCH_SEGMENTATION_INTERESTS_TYPE,
  ADS_CAMPAIGN_SEARCH_SEGMENTATION_LOCATIONS_TYPE,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_APP_OPTION,
  ADS_CAMPAIGN_TIKTOK_DESTINATION_TYPE_EXTERNAL_WEBSITE,
  ADS_CAMPAIGN_TIKTOK_DESTINATION_TYPE_INSTANT_PAGE,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
  ADS_TIKTOK_PLACEMENT_PANGLE,
  ADS_TIKTOK_PLACEMENT_TIKTOK,
  ALERT_ICON_TYPE_SUCCESS,
  BORDER_RADIUS,
  LABELS_TRACKING_CUSTOM_EVENTS,
  LABELS_TRACKING_ID,
  MIN_WIDTH_SCREEN_TO_SHOW_CHAT,
  TIKTOK,
} from "../../../../utils/constants";
import { Controller, useFormContext } from "react-hook-form";
import useFocusErrorForm from "../../../../hooks/useFocusErrorForm";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Slider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Checkbox from "../../../Form/Checkbox";
import {
  AD_SCHEDULE_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE,
  ADS_CONFIGURATION_APPS_TITLE,
  AGE_RANGE_PLACEHOLDER,
  CATALOG_PLACEHOLDER,
  BEHAVIORS_PLACEHOLDER,
  BUDGET_CAMPAIGN_DATES_PLACEHOLDER,
  COPY_VALUE_IN_OTHER_ADGROUPS,
  DAILY_BUDGET_PLACEHOLDER,
  DEMOGRAPHICS_BASIC_PLACEHOLDER,
  DESTINATION_TYPE_PLACEHOLDER,
  END_DATE_PLACEHOLDER,
  FEMALES,
  FIELD_REQUIRED,
  GENDERS_PLACEHOLDER,
  INTERESTS_PLACEHOLDER,
  LANGUAGES_PLACEHOLDER,
  LIFETIME_BUDGET_PLACEHOLDER,
  LOCATIONS_PLACEHOLDER,
  LOCATIONS_TIK_TOK_EMPTY,
  MALES,
  PRODUCT_SET_AUDIENCE_BUILDER_TITLE,
  READY,
  START_DATE_PLACEHOLDER,
  SUGGESTION_BUDGET_APPLY,
  SUGGESTION_BUDGET_CANCEL,
  SUGGESTION_BUDGET_TITLE,
  TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION,
  TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL,
  TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION,
  TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL,
  TIKTOK_ADGROUP_PLACEMENTS_TITLE,
  TYPE_BUDGET_PLACEHOLDER,
  TIKTOK_INSTANT_FORM_LOCKED_DESTINATION,
} from "../../../../i18n/keysTranslations";
import Select from "../../../Form/Select";
import { addDays, differenceInDays, endOfDay, startOfDay } from "date-fns";
import {
  marksAge,
  optionsAdsCampaignTypeBudgets,
  optionsTikTokLeadDestinationType,
} from "../../../../utils/options";
import TextField from "../../../Form/TextField";
import { textNumberCompactFormat } from "../../../../utils/numbers";
import DateTimeField from "../../../Form/DateTimeField";
import {
  GREY_SLIDER_COLOR,
  INPUT_COLOR_BORDER,
} from "../../../../utils/colors";
import CheckBoxes from "../../../Form/CheckBoxes";
import SearchSegmentationsField from "../../../Form/SearchSegmentationsField";
import { waitDelay } from "../../../../utils/date";
import { useDispatchApp } from "../../../../lib/redux";
import { getCurrencyAdAccountPlatform } from "../../../../actions/getters";
import NumberField from "../../../Form/NumberField";
import SelectCustomEventAds from "../../../Form/SelectCustomEventAds";
import SelectTrackingIDField from "../../../Form/SelectTrackingIDField";
import _ from "lodash";
import Box from "@mui/material/Box";
import ClickableText from "../../../Texts/ClickableText";
import { ConfirmAlert, SimpleAlert } from "../../../Alerts/Alerts";
import SelectAdvertisableAppsTikTok from "./SelectAdvertisableAppsTikTok";
import AdGroupCustomAudiencesContainerTikTok from "./AdGroupCustomAudiencesContainerTikTok";
import WeeklyTimeSelector from "../../../../pages/NewAdsCampaign/components/Common/WeeklyTimeSelector";
import {
  AdsClickOutlined,
  Category,
  Favorite,
  LocationOnOutlined,
  People,
  Person,
  TrendingUp,
  KeyboardArrowUp,
  KeyboardArrowDown,
  Paid,
} from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AppsIcon from "@mui/icons-material/Apps";
import SelectAppEventTikTok from "./SelectAppEventTikTok";
import SelectCatalogTikTok from "../Campaign/SelectCatalogTikTok";
import BidGoalTikTok from "./BidGoalTikTok";
import BudgetSuggestionsAlert from "../../../Alerts/BudgetSuggestionsAlert";
import CardContainer from "../../../Card/CardContainer";
import { getMinimumBudget } from "../../../../services/adsCampaigns";
import SelectLanguagesTikTokForm from "./SelectLanguagesTikTokForm";
import ChipOptional from "../../../Chip/ChipOptional";
import AudienceEstimatesPreviewTikTok from "./AudienceEstimatesPreviewTikTok";
import ProductSetAudienceBuilderTikTok from "./ProductSetAudienceBuilderTikTok";
import { alertIfEmptyCopyValue } from "../../../../utils/copyFormValue";
import { copySectionValue } from "../../../../utils/aiGeneratedForm";
import {
  ChipAIGeneratedAnySection,
  ChipAIGeneratedSection,
} from "../../../Chip/ChipAIGenerated";
import { AI_GENERATED_DEMOGRAPHICS_BASIC_SECTIONS } from "../../../../utils/aiGenerated";

const platform = TIKTOK;
const APP_OS_IOS = "ios";
const APP_OS_ANDROID = "android";
/** Empty catalog audience shape; Android may keep this until the user picks retargeting rules. */
const EMPTY_PRODUCT_SET_AUDIENCE = {
  inclusions: [],
  exclusions: [],
};

/**
 * Maps a TikTok advertisable app option to our form `appOS` value.
 * API returns `platform: "IOS" | "ANDROID"`. Unknown/missing platform defaults to iOS
 * so catalog rules stay strict unless we clearly have Android.
 */
const getAppOSFromTikTokAppOption = (option) => {
  if (!option) return "";
  const p = String(option.platform || "").toUpperCase();
  if (p === "IOS") return APP_OS_IOS;
  if (p === "ANDROID") return APP_OS_ANDROID;
  return APP_OS_IOS;
};

const grid = {
  xs: 12,
  lg: 6,
};
const gridDates = {
  xs: 12,
  xl: 6,
};
const AdGroupTikTokForm = () => (
  <AdGroupSelectionGate>
    <AdGroupTikTokFormContent />
  </AdGroupSelectionGate>
);

const AdGroupTikTokFormContent = () => {
  const isFirstRender = useRef(true);
  const [isLoading, setIsLoading] = useState(true);
  const [pixels, setPixels] = useState([]);
  const [interestsOpen, setInterestsOpen] = useState(true);
  const [behaviorOpen, setBehaviorOpen] = useState(true);
  const {
    control,
    formState,
    setValue,
    watch,
    sectionSelected,
    isGeneralDisabledFields,
    getValues,
    trigger,
    isChatVisible,
  } = useFormContext();
  useFocusErrorForm(formState);

  const errors = formState.errors;

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();

  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isLargeScreen = useMediaQuery(
    () => `(min-width: ${MIN_WIDTH_SCREEN_TO_SHOW_CHAT}px)`
  );
  const showSlideChat = isChatVisible && isLargeScreen;

  const isCampaignImported = getValues("isImported");
  const { index, BASIC_PATH } = useRequiredAdGroupSelection();

  const platformData = watch(`platformsData.${platform}`) || {};
  const isIOS14Campaign = watch(`${BASIC_PATH}.isIOS14Campaign`) || false;
  const campaignType = platformData.type;
  const useCampaignBudget = platformData?.useCampaignBudget || false;
  const objective = platformData?.objective;
  const isAppPromotionCampaign =
    objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION;
  const isIncompatibleCampaign = platformData?.isIncompatible;
  const locations = watch(`${BASIC_PATH}.locations`) || [];
  const genders = watch(`${BASIC_PATH}.genders`) || {};
  const typeBudget = watch(`${BASIC_PATH}.typeBudget`) || "";
  const trackingID = watch(`${BASIC_PATH}.trackingID`) || "";
  const destinationType = watch(`${BASIC_PATH}.destinationType`) || "";
  const isLeadsCampaign = objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION;
  const isInstantFormLead =
    isLeadsCampaign &&
    destinationType === ADS_CAMPAIGN_TIKTOK_DESTINATION_TYPE_INSTANT_PAGE;
  const language = watch("language") || "";
  const startDate = watch(`${BASIC_PATH}.startDate`) || null;
  const endDate = watch(`${BASIC_PATH}.endDate`) || null;
  const isIncompatibleAdGroup = watch(`${BASIC_PATH}.isIncompatible`) || false;
  const status = watch(`${BASIC_PATH}.status`) || ADS_CAMPAIGN_STATUS_DRAFT;
  const appOS = watch(`${BASIC_PATH}.appOS`) || "";

  const isAdGroupCreated = status !== ADS_CAMPAIGN_STATUS_DRAFT;
  const isSelectedAppAndroid = appOS === APP_OS_ANDROID;

  const appID = watch(`${BASIC_PATH}.appID`) || "";

  const isDisabledFields =
    isGeneralDisabledFields || isIncompatibleCampaign || isIncompatibleAdGroup;

  const pixelSelected = _.isEmpty(pixels)
    ? {}
    : pixels.find((p) => p.id === trackingID);

  const currency = dispatch(
    getCurrencyAdAccountPlatform({
      platform,
      integrationID: platformData?.integrationID,
      adAccountID: platformData?.adAccountID,
    })
  );

  const adGroupBudget = watch(`${BASIC_PATH}.budget`) || null;
  const isEffectiveBudget = adGroupBudget > 0;

  const initialDatesRef = useRef({ startDate, endDate });

  // Extract complex expressions to memoized variables for static checking
  const startDateValue = useMemo(
    () => startOfDay(startDate).getTime(),
    [startDate]
  );
  const endDateValue = useMemo(() => startOfDay(endDate).getTime(), [endDate]);

  useEffect(() => {
    initialDatesRef.current = {
      startDate: startOfDay(startDate),
      endDate: startOfDay(endDate),
    };
    // eslint-disable-next-line
  }, [typeBudget]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      initialDatesRef.current = {
        startDate: startOfDay(startDate),
        endDate: startOfDay(endDate),
      };
      return;
    }

    const onBudgetSuggestion = async () => {
      if (
        typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION &&
        isEffectiveBudget
      ) {
        const initialStart = initialDatesRef.current.startDate;
        const initialEnd = initialDatesRef.current.endDate;
        const currentStartDay = startOfDay(startDate);
        const currentEndDay = startOfDay(endDate);

        const initialDays = differenceInDays(initialEnd, initialStart) || 1;
        const newDays = differenceInDays(currentEndDay, currentStartDay) || 1;

        if (newDays > initialDays) {
          const budgetMinimum = getMinimumBudget({
            platform,
            typeBudget,
            startDateTime: currentStartDay,
            endDateTime: currentEndDay,
            currency,
          });

          const dailyBudget = adGroupBudget / initialDays;
          const suggestedBudget = Math.round(dailyBudget * newDays);

          const result = await ConfirmAlert({
            title: t(SUGGESTION_BUDGET_TITLE),
            html: (
              <BudgetSuggestionsAlert
                effectiveBudget={adGroupBudget}
                budgetMinimum={budgetMinimum}
                suggestedBudget={suggestedBudget}
                currency={currency}
              />
            ),
            confirmButtonText: t(SUGGESTION_BUDGET_APPLY),
            cancelButtonText: t(SUGGESTION_BUDGET_CANCEL),
          });
          if (result.isConfirmed) {
            setValue(`${BASIC_PATH}.budget`, suggestedBudget, {
              shouldValidate: true,
              shouldDirty: true,
            });
            initialDatesRef.current = {
              startDate: currentStartDay,
              endDate: currentEndDay,
            };
          }
        }
      }
    };

    onBudgetSuggestion();
    // eslint-disable-next-line
  }, [startDateValue, endDateValue, typeBudget]);

  const onCopyValuesInOtherAds = ({ type }) => {
    const value = getValues(`${BASIC_PATH}.${type}`);
    if (alertIfEmptyCopyValue({ value, t })) return;
    const adsGroups = toAdsGroupsList(getValues("adsGroups"));
    const appOSValue = getValues(`${BASIC_PATH}.appOS`);

    adsGroups.forEach((adGroup, currentIndexAdGroup) => {
      if (adGroup.platform !== platform) return;

      copySectionValue({
        setValue,
        getValues,
        sourceBasePath: BASIC_PATH,
        section: type,
        platform,
        entityType: "adGroup",
        path: `adsGroups.[${currentIndexAdGroup}].${type}`,
        value,
      });

      if (type === "appID") {
        setValue(`adsGroups.[${currentIndexAdGroup}].appOS`, appOSValue, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    });

    SimpleAlert({
      title: t(READY),
      icon: ALERT_ICON_TYPE_SUCCESS,
    });
  };

  const isCatalogCampaignTikTok =
    objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
    campaignType === ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_APP_OPTION;

  /**
   * Runs when the advertisable app changes (user pick) or when the select rehydrates
   * the full option from `appID` (`syncOnly: true` from `SelectAdvertisableAppsTikTok`).
   *
   * Always keeps `appOS` in sync with the selected app metadata (`platform`).
   *
   * Catalog + app campaigns only (`isCatalogCampaignTikTok`):
   * - Clearing the app: reset `productSetAudience` to empty if it had rules.
   * - Android: normalize to `EMPTY_PRODUCT_SET_AUDIENCE` when switching onto Android from
   *   another OS or when there was any audience data (fresh Android row starts empty/optional).
   * - iOS after Android with an empty audience: set `productSetAudience` to `undefined` so
   *   `ProductSetAudienceBuilderTikTok` can run its iOS initialization effect.
   *
   * Non-catalog: only `appOS` / app clearing / tracking reset apply.
   *
   * `syncOnly`: prefer not marking the form dirty when we only mirror API-backed metadata
   * on mount or re-select without a user change.
   */
  const onSyncSelectedApp = useCallback(
    (value, { syncOnly = false } = {}) => {
      const nextAppID = value?.id || "";
      const nextAppOS = !value ? "" : getAppOSFromTikTokAppOption(value);
      const currentAppID = getValues(`${BASIC_PATH}.appID`) || "";
      const currentAppOS = getValues(`${BASIC_PATH}.appOS`) || "";
      const productSetAudience = getValues(`${BASIC_PATH}.productSetAudience`);
      const isEmptyProductSetAudience =
        _.isEmpty(productSetAudience?.inclusions) &&
        _.isEmpty(productSetAudience?.exclusions);

      // Persist derived OS for gating catalog audience (iOS mandatory vs Android optional).
      if (nextAppOS !== currentAppOS) {
        setValue(`${BASIC_PATH}.appOS`, nextAppOS, {
          shouldDirty: !syncOnly,
        });
      }

      if (!value) {
        if (currentAppOS) {
          setValue(`${BASIC_PATH}.appOS`, "", {
            shouldDirty: !syncOnly,
          });
        }
        if (isCatalogCampaignTikTok) {
          if (!isEmptyProductSetAudience) {
            setValue(
              `${BASIC_PATH}.productSetAudience`,
              EMPTY_PRODUCT_SET_AUDIENCE,
              {
                shouldDirty: !syncOnly,
              }
            );
          }
        }
        return;
      }

      // App identity changed: drop custom event tied to the previous app.
      if (!syncOnly && currentAppID !== nextAppID) {
        setValue(`${BASIC_PATH}.trackingCustomEventID`, "");
      }

      if (!isCatalogCampaignTikTok) return;

      // Android catalog: start from empty audience unless user fills retargeting in the builder.
      if (nextAppOS === APP_OS_ANDROID) {
        if (currentAppOS !== APP_OS_ANDROID || !isEmptyProductSetAudience) {
          setValue(
            `${BASIC_PATH}.productSetAudience`,
            EMPTY_PRODUCT_SET_AUDIENCE,
            {
              shouldDirty: !syncOnly,
            }
          );
        }
        return;
      }

      // iOS after Android with no rules: unset so the builder applies mandatory default preset.
      if (currentAppOS === APP_OS_ANDROID && isEmptyProductSetAudience) {
        setValue(`${BASIC_PATH}.productSetAudience`, undefined, {
          shouldDirty: !syncOnly,
        });
      }
    },
    [BASIC_PATH, getValues, isCatalogCampaignTikTok, setValue]
  );

  //To reset values component when change selectedLevel
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await waitDelay(1);
      setIsLoading(false);
    })();
  }, [sectionSelected]);

  useEffect(() => {
    if (!isLeadsCampaign || destinationType) return;
    setValue(
      `${BASIC_PATH}.destinationType`,
      ADS_CAMPAIGN_TIKTOK_DESTINATION_TYPE_EXTERNAL_WEBSITE,
      { shouldDirty: false, shouldValidate: false }
    );
  }, [BASIC_PATH, destinationType, index, isLeadsCampaign, setValue]);

  const onChangeLeadDestination = (value) => {
    if (value === ADS_CAMPAIGN_TIKTOK_DESTINATION_TYPE_INSTANT_PAGE) {
      setValue(`${BASIC_PATH}.trackingID`, "", {
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue(`${BASIC_PATH}.trackingCustomEventID`, "", {
        shouldDirty: true,
        shouldValidate: true,
      });
      return;
    }

    const ads = getValues(`${BASIC_PATH}.ads`) || [];
    ads.forEach((_, indexAd) => {
      setValue(`${BASIC_PATH}.ads.[${indexAd}].instantForm`, null, {
        shouldDirty: true,
        shouldValidate: true,
      });
    });
  };

  if (isLoading) return null;

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: isTabletOrMobile || showSlideChat ? "column" : "row",
        gap: 2,
      }}
    >
      {/* Forms Column */}
      <Box
        sx={{
          flex: 1,
          maxWidth:
            isTabletOrMobile || showSlideChat ? "100%" : "calc(100% - 420px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 3,
          order: isTabletOrMobile || showSlideChat ? 2 : 1, // Segundo en mobile/tablet, primero en desktop
        }}
      >
        <Grid container spacing={3}>
          {/* App promotion campaign configuration */}
          {(isAppPromotionCampaign || isCatalogCampaignTikTok) && (
            <Grid item xs={12}>
              <CardContainer
                title={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AppsIcon
                      sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(ADS_CONFIGURATION_APPS_TITLE)}
                    </Typography>
                  </Box>
                }
              >
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <SelectAdvertisableAppsTikTok
                      disabled={
                        isAdGroupCreated || isDisabledFields || isIOS14Campaign
                      }
                      platform={TIKTOK}
                      adAccountID={platformData?.adAccountID}
                      integrationID={platformData?.integrationID}
                      name={`${BASIC_PATH}.appID`}
                      onChangeAction={onSyncSelectedApp}
                      isIOS14Campaign={isIOS14Campaign}
                      campaignType={campaignType}
                      fullWidth
                      variant="filled"
                      control={control}
                      errors={errors}
                    />
                    <ClickableText
                      onClick={() => onCopyValuesInOtherAds({ type: "appID" })}
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </Grid>
                  {(campaignType ===
                    ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION ||
                    isCatalogCampaignTikTok) && (
                    <Grid item xs={6}>
                      <SelectAppEventTikTok
                        disabled={isAdGroupCreated || isDisabledFields}
                        platform={TIKTOK}
                        adAccountID={platformData?.adAccountID}
                        integrationID={platformData?.integrationID}
                        appID={appID}
                        name={`${BASIC_PATH}.trackingCustomEventID`}
                        campaignType={campaignType}
                        fullWidth
                        variant="filled"
                        control={control}
                        errors={errors}
                      />
                      <ClickableText
                        onClick={() =>
                          onCopyValuesInOtherAds({
                            type: "trackingCustomEventID",
                          })
                        }
                      >
                        {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                      </ClickableText>
                    </Grid>
                  )}
                </Grid>
              </CardContainer>
            </Grid>
          )}

          {/* Catalog campaign configuration - separate section below app config */}
          {isCatalogCampaignTikTok && (
            <Grid item xs={12}>
              <CardContainer
                title={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Category
                      sx={{
                        color: "#FFFFFF",
                        width: 24,
                        height: 24,
                      }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(CATALOG_PLACEHOLDER)}
                    </Typography>
                  </Box>
                }
              >
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <SelectCatalogTikTok
                      control={control}
                      name={`${BASIC_PATH}.catalogID`}
                      fullWidth
                      variant="filled"
                      integrationID={platformData?.integrationID}
                      adAccountID={platformData?.adAccountID}
                      disabled={isAdGroupCreated || isDisabledFields}
                      errors={errors}
                      rules={{
                        required: {
                          value: true,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                    <ClickableText
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "catalogID" })
                      }
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </Grid>
                </Grid>
              </CardContainer>
            </Grid>
          )}

          {/* Card Destination type - hidden for catalog (sales + app) */}
          {!isCatalogCampaignTikTok &&
            ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_TIKTOK.includes(
              objective
            ) && (
              <Grid item xs={12}>
                <CardContainer
                  title={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AdsClickOutlined
                        sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                      />
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {t(DESTINATION_TYPE_PLACEHOLDER)}
                      </Typography>
                    </Box>
                  }
                >
                  <Grid container spacing={3}>
                    {isLeadsCampaign && (
                      <Grid item xs={12}>
                        <Select
                          name={`${BASIC_PATH}.destinationType`}
                          disabled={isAdGroupCreated || isDisabledFields}
                          fullWidth
                          variant="filled"
                          doTranslate={true}
                          options={optionsTikTokLeadDestinationType}
                          control={control}
                          errors={errors}
                          actionsChange={onChangeLeadDestination}
                        />
                        {isAdGroupCreated && (
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            {t(TIKTOK_INSTANT_FORM_LOCKED_DESTINATION)}
                          </Typography>
                        )}
                      </Grid>
                    )}
                    {!isInstantFormLead && (
                      <>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: "column",
                              width: "100%",
                              gap: 1,
                            }}
                          >
                            <Typography variant="body1">
                              {t(LABELS_TRACKING_ID[platform])}
                            </Typography>
                            <SelectTrackingIDField
                              name={`${BASIC_PATH}.trackingID`}
                              disabled={isAdGroupCreated || isDisabledFields}
                              fullWidth
                              variant="filled"
                              platform={platform}
                              integrationID={platformData?.integrationID}
                              adAccountID={platformData?.adAccountID}
                              onLoadOptions={(newPixels) => {
                                setPixels(newPixels);
                              }}
                              onChangeAction={() => {
                                setValue(
                                  `${BASIC_PATH}.trackingCustomEventID`,
                                  ""
                                );
                              }}
                              control={control}
                              errors={errors}
                              rules={{
                                required: {
                                  value: true,
                                  message: t(FIELD_REQUIRED),
                                },
                              }}
                            />
                          </Box>
                          <ClickableText
                            onClick={() =>
                              onCopyValuesInOtherAds({ type: "trackingID" })
                            }
                          >
                            {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                          </ClickableText>
                        </Grid>

                        <Grid item xs={6}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: "column",
                              width: "100%",
                              gap: 1,
                            }}
                          >
                            <Typography variant="body1">
                              {t(LABELS_TRACKING_CUSTOM_EVENTS[platform])}
                            </Typography>

                            <SelectCustomEventAds
                              name={`${BASIC_PATH}.trackingCustomEventID`}
                              platform={platform}
                              variant="filled"
                              disabled={isAdGroupCreated || isDisabledFields}
                              integrationID={platformData?.integrationID}
                              adAccountID={platformData?.adAccountID}
                              pixelSelected={pixelSelected}
                              objective={objective}
                              control={control}
                              errors={errors}
                              fullWidth={true}
                              rules={{
                                required: {
                                  value: true,
                                  message: t(FIELD_REQUIRED),
                                },
                              }}
                            />
                            <ClickableText
                              onClick={() =>
                                onCopyValuesInOtherAds({
                                  type: "trackingCustomEventID",
                                })
                              }
                            >
                              {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                            </ClickableText>
                          </Box>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </CardContainer>
              </Grid>
            )}

          {/* Catalog campaign configuration */}
          {isCatalogCampaignTikTok && (
            <Grid item xs={12}>
              <CardContainer
                title={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <People
                      sx={{
                        color: "#FFFFFF",
                        width: 24,
                        height: 24,
                        fontWeight: 600,
                      }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(PRODUCT_SET_AUDIENCE_BUILDER_TITLE)}
                    </Typography>
                  </Box>
                }
              >
                <Grid item xs={12}>
                  <ProductSetAudienceBuilderTikTok
                    control={control}
                    name={`${BASIC_PATH}.productSetAudience`}
                    errors={errors}
                    allowEmptyAudience={isSelectedAppAndroid}
                  />
                </Grid>
              </CardContainer>
            </Grid>
          )}

          {/* Card Budget information */}
          {(!useCampaignBudget ||
            typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION) && (
            <Grid item xs={12}>
              <CardContainer
                title={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {useCampaignBudget ? (
                      <CalendarMonthIcon
                        sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                      />
                    ) : (
                      <Paid sx={{ color: "#FFFFFF", width: 24, height: 24 }} />
                    )}
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(
                        useCampaignBudget
                          ? BUDGET_CAMPAIGN_DATES_PLACEHOLDER
                          : ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE
                      )}
                    </Typography>
                  </Box>
                }
              >
                <Grid container spacing={3}>
                  {/* Type budget */}
                  {!useCampaignBudget && (
                    <>
                      <Grid item {...grid}>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                          {t(TYPE_BUDGET_PLACEHOLDER)}
                        </Typography>
                        <Select
                          disabled={isAdGroupCreated || isDisabledFields}
                          name={`${BASIC_PATH}.typeBudget`}
                          actionsChange={(value) => {
                            if (
                              value === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION
                            ) {
                              setValue(
                                `${BASIC_PATH}.startDate`,
                                startOfDay(new Date()),
                                { shouldValidate: true, shouldDirty: true }
                              );
                              setValue(
                                `${BASIC_PATH}.endDate`,
                                endOfDay(addDays(new Date(), 1)),
                                { shouldValidate: true, shouldDirty: true }
                              );
                            }
                          }}
                          fullWidth
                          variant="filled"
                          doTranslate={true}
                          options={optionsAdsCampaignTypeBudgets}
                          control={control}
                          errors={errors}
                          rules={{
                            required: {
                              value: true,
                              message: t(FIELD_REQUIRED),
                            },
                          }}
                        />
                        <ClickableText
                          onClick={() =>
                            onCopyValuesInOtherAds({ type: "typeBudget" })
                          }
                        >
                          {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                        </ClickableText>
                      </Grid>
                      <Grid item {...grid}>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                          {t(
                            typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION
                              ? DAILY_BUDGET_PLACEHOLDER
                              : LIFETIME_BUDGET_PLACEHOLDER,
                            {
                              currency: currency.toUpperCase(),
                            }
                          )}
                        </Typography>
                        <TextField
                          name={`${BASIC_PATH}.budget`}
                          disabled={isDisabledFields}
                          fullWidth
                          variant="filled"
                          InputProps={{
                            inputComponent: NumberField,
                          }}
                          control={control}
                          errors={errors}
                          rules={{
                            required: {
                              value: true,
                              message: t(FIELD_REQUIRED),
                            },
                          }}
                        />
                        <ClickableText
                          onClick={() =>
                            onCopyValuesInOtherAds({ type: "budget" })
                          }
                        >
                          {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                        </ClickableText>
                      </Grid>
                    </>
                  )}

                  {/* Start date and end date */}
                  {typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION && (
                    <>
                      <Grid item {...gridDates}>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                          {t(START_DATE_PLACEHOLDER)}
                        </Typography>
                        <DateTimeField
                          disabled={
                            (isAdGroupCreated || isDisabledFields) && startDate
                          }
                          minDate={startOfDay(new Date())}
                          name={`${BASIC_PATH}.startDate`}
                          id={`${BASIC_PATH}.startDate`}
                          control={control}
                          errors={errors}
                          showStartNowButton={true}
                        />
                        <ClickableText
                          onClick={() =>
                            onCopyValuesInOtherAds({ type: "startDate" })
                          }
                        >
                          {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                        </ClickableText>
                      </Grid>

                      <Grid item {...gridDates}>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                          {t(END_DATE_PLACEHOLDER)}
                        </Typography>
                        <DateTimeField
                          disabled={isDisabledFields}
                          name={`${BASIC_PATH}.endDate`}
                          actionsChange={() => {
                            trigger(`${BASIC_PATH}.budget`);
                          }}
                          minDate={addDays(
                            new Date(startDate || new Date()),
                            1
                          )}
                          id={`${BASIC_PATH}.endDate`}
                          control={control}
                          errors={errors}
                        />
                        <ClickableText
                          onClick={() =>
                            onCopyValuesInOtherAds({ type: "endDate" })
                          }
                        >
                          {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                        </ClickableText>
                      </Grid>
                    </>
                  )}

                  <Grid item {...grid}>
                    <BidGoalTikTok
                      currency={currency}
                      objective={objective}
                      campaignType={campaignType}
                      disabled={
                        isDisabledFields ||
                        (isAdGroupCreated &&
                          objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION)
                      }
                      control={control}
                      errors={errors}
                      name={`${BASIC_PATH}.bidGoal`}
                    />
                  </Grid>
                </Grid>
              </CardContainer>
            </Grid>
          )}

          {/* Card Schedule */}
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CalendarMonthIcon
                    sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                  />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(AD_SCHEDULE_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Grid item xs={12}>
                <WeeklyTimeSelector
                  name={`${BASIC_PATH}.schedule`}
                  control={control}
                  platform={platform}
                  disabled={isDisabledFields}
                />
                <ClickableText
                  onClick={() => onCopyValuesInOtherAds({ type: "schedule" })}
                >
                  {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                </ClickableText>
              </Grid>
            </CardContainer>
          </Grid>

          {/* Placements — Pangle choice only for traffic, sales, leads, app */}
          {ADS_CAMPAIGN_OBJECTIVES_WITH_PLACEMENT_SELECTOR_TIKTOK.includes(
            objective
          ) && (
            <Grid item xs={12}>
              <CardContainer
                title={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AdsClickOutlined
                      sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(TIKTOK_ADGROUP_PLACEMENTS_TITLE)}
                    </Typography>
                  </Box>
                }
              >
                <Controller
                  name={`${BASIC_PATH}.placements`}
                  control={control}
                  render={({ field: { value, onChange } }) => {
                    const currentValue = Array.isArray(value)
                      ? value
                      : [ADS_TIKTOK_PLACEMENT_TIKTOK];
                    const pangleChecked = currentValue.includes(
                      ADS_TIKTOK_PLACEMENT_PANGLE
                    );

                    const onTogglePangle = (checked) => {
                      onChange(
                        checked
                          ? [
                              ADS_TIKTOK_PLACEMENT_TIKTOK,
                              ADS_TIKTOK_PLACEMENT_PANGLE,
                            ]
                          : [ADS_TIKTOK_PLACEMENT_TIKTOK]
                      );
                    };

                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1.5,
                        }}
                      >
                        {/* TikTok — always active, never toggleable */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          <Checkbox checked disabled sx={{ mt: 0.5 }} />
                          <Box>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600 }}
                            >
                              {t(TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL)}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {t(TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION)}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Pangle — optional */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          <Checkbox
                            checked={pangleChecked}
                            disabled={isAdGroupCreated || isDisabledFields}
                            onChange={(e) => onTogglePangle(e.target.checked)}
                            sx={{ mt: 0.5 }}
                          />
                          <Box>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600 }}
                            >
                              {t(TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL)}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {t(TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION)}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    );
                  }}
                />
              </CardContainer>
            </Grid>
          )}

          {/* Audience Segmentation */}
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <People
                    sx={{
                      color: "#FFFFFF",
                      width: 24,
                      height: 24,
                      fontWeight: 600,
                    }}
                  />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <Box>
                <AdGroupCustomAudiencesContainerTikTok
                  BASIC_PATH={BASIC_PATH}
                  name={`${BASIC_PATH}.customAudiences`}
                  control={control}
                  errors={errors}
                  disabled={isDisabledFields}
                />
                <Divider sx={{ my: 2 }} />
                <AdGroupCustomAudiencesContainerTikTok
                  BASIC_PATH={BASIC_PATH}
                  name={`${BASIC_PATH}.excludedCustomAudiences`}
                  control={control}
                  errors={errors}
                  disabled={isDisabledFields}
                  isExcludedAudiences={true}
                />
              </Box>
            </CardContainer>
          </Grid>

          {/* Demographics & Targeting */}
          <Grid item xs={12}>
            <Grid container spacing={3}>
              {/* Age & Gender */}
              <Grid item xs={12} md={6}>
                <CardContainer
                  title={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexWrap: "wrap",
                      }}
                    >
                      <Person
                        sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                      />
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {t(DEMOGRAPHICS_BASIC_PLACEHOLDER)}
                      </Typography>
                      <ChipAIGeneratedAnySection
                        basePath={BASIC_PATH}
                        sections={AI_GENERATED_DEMOGRAPHICS_BASIC_SECTIONS}
                      />
                    </Box>
                  }
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" sx={{ mb: 2 }}>
                        {t(AGE_RANGE_PLACEHOLDER)}
                      </Typography>
                      <Controller
                        name={`${BASIC_PATH}.ageRange`}
                        id={`${BASIC_PATH}.ageRange`}
                        control={control}
                        render={({ field }) => (
                          <Slider
                            sx={{
                              width: "calc(100% - 24px)",
                              ml: 1,
                              ".MuiSlider-track": {
                                height: 2,
                              },
                              ".MuiSlider-rail": {
                                backgroundColor: GREY_SLIDER_COLOR,
                                height: 4,
                              },
                              ".MuiSlider-mark": {
                                backgroundColor: "transparent",
                              },
                            }}
                            valueLabelDisplay="auto"
                            getAriaValueText={textNumberCompactFormat}
                            step={1}
                            marks={marksAge}
                            min={18}
                            max={65}
                            valueLabelFormat={textNumberCompactFormat}
                            {...field}
                            disabled={isDisabledFields}
                          />
                        )}
                      />
                    </Grid>
                    <Divider />
                    <Grid item xs={12}>
                      <CheckBoxes
                        name={`${BASIC_PATH}.genders`}
                        disabled={isDisabledFields}
                        label={GENDERS_PLACEHOLDER}
                        options={[
                          {
                            key: "male",
                            label: MALES,
                          },
                          {
                            key: "female",
                            label: FEMALES,
                          },
                        ]}
                        control={control}
                        errors={errors}
                        rules={{
                          validate: () => {
                            if (!Object.values(genders).includes(true)) {
                              return t(FIELD_REQUIRED);
                            }
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContainer>
              </Grid>

              {/* Location */}
              {!isCampaignImported && (
                <Grid item xs={12} md={6}>
                  <CardContainer
                    title={
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <LocationOnOutlined
                          sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                        />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {t(LOCATIONS_PLACEHOLDER)}
                        </Typography>
                      </Box>
                    }
                    sxContainer={{
                      height: "100%",
                    }}
                  >
                    {!isCampaignImported && (
                      <>
                        <Grid item xs={12}>
                          <SearchSegmentationsField
                            name={`${BASIC_PATH}.locations`}
                            type={
                              ADS_CAMPAIGN_SEARCH_SEGMENTATION_LOCATIONS_TYPE
                            }
                            mode="fetching"
                            platform={platform}
                            adAccountID={platformData?.adAccountID}
                            integrationID={platformData?.integrationID}
                            objective={objective}
                            language={language}
                            fullWidth
                            variant="filled"
                            disabled={isDisabledFields}
                            helperText={
                              locations.length === 0 || !locations
                                ? t(LOCATIONS_TIK_TOK_EMPTY)
                                : ""
                            }
                            control={control}
                            errors={errors}
                            rules={{
                              required: {
                                value: true,
                                message: t(FIELD_REQUIRED),
                              },
                            }}
                          />
                          <ClickableText
                            onClick={() =>
                              onCopyValuesInOtherAds({ type: "locations" })
                            }
                          >
                            {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                          </ClickableText>
                        </Grid>
                        <Grid item xs={12}>
                          <Box sx={{ mt: 2 }}>
                            <Box
                              sx={{
                                mb: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Typography variant="subtitle1">
                                {t(LANGUAGES_PLACEHOLDER)}
                              </Typography>
                              <ChipOptional size="small" />
                            </Box>
                            <SelectLanguagesTikTokForm
                              name={`${BASIC_PATH}.languages`}
                              control={control}
                              errors={errors}
                              disabled={isDisabledFields}
                            />
                            <ClickableText
                              onClick={() =>
                                onCopyValuesInOtherAds({ type: "languages" })
                              }
                            >
                              {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                            </ClickableText>
                          </Box>
                        </Grid>
                      </>
                    )}
                  </CardContainer>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Card Interests */}
          {!isCampaignImported && (
            <Grid item xs={12}>
              <Card
                sx={{
                  backgroundColor: "fields.background",
                  border: `1px solid ${INPUT_COLOR_BORDER}`,
                  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                  borderRadius: BORDER_RADIUS,
                  p: 1,
                }}
              >
                <CardHeader
                  onClick={() => setInterestsOpen(!interestsOpen)}
                  sx={{
                    cursor: "pointer",
                  }}
                  title={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Favorite
                          sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                        />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {t(INTERESTS_PLACEHOLDER)}
                        </Typography>
                        <ChipAIGeneratedSection
                          basePath={BASIC_PATH}
                          section="interests"
                        />
                      </Box>
                      {interestsOpen ? (
                        <KeyboardArrowUp sx={{ color: "#9CA3AF" }} />
                      ) : (
                        <KeyboardArrowDown sx={{ color: "#9CA3AF" }} />
                      )}
                    </Box>
                  }
                />
                {interestsOpen && (
                  <CardContent>
                    <SearchSegmentationsField
                      name={`${BASIC_PATH}.interests`}
                      type={ADS_CAMPAIGN_SEARCH_SEGMENTATION_INTERESTS_TYPE}
                      mode="fetching"
                      platform={platform}
                      adAccountID={platformData?.adAccountID}
                      integrationID={platformData?.integrationID}
                      objective={objective}
                      language={language}
                      fullWidth
                      variant="filled"
                      disabled={isDisabledFields}
                      control={control}
                      errors={errors}
                      rules={{
                        required: {
                          value: false,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                    <ClickableText
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "interests" })
                      }
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </CardContent>
                )}
              </Card>
            </Grid>
          )}

          {/* Card Behaviors */}
          {!isCampaignImported && (
            <Grid item xs={12}>
              <Card
                sx={{
                  backgroundColor: "fields.background",
                  border: `1px solid ${INPUT_COLOR_BORDER}`,
                  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                  borderRadius: BORDER_RADIUS,
                  p: 1,
                }}
              >
                <CardHeader
                  onClick={() => setBehaviorOpen(!behaviorOpen)}
                  sx={{
                    cursor: "pointer",
                  }}
                  title={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <TrendingUp
                          sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                        />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {t(BEHAVIORS_PLACEHOLDER)}
                        </Typography>
                        <ChipAIGeneratedSection
                          basePath={BASIC_PATH}
                          section="behaviors"
                        />
                      </Box>
                      {behaviorOpen ? (
                        <KeyboardArrowUp sx={{ color: "#9CA3AF" }} />
                      ) : (
                        <KeyboardArrowDown sx={{ color: "#9CA3AF" }} />
                      )}
                    </Box>
                  }
                />
                {behaviorOpen && (
                  <CardContent>
                    <SearchSegmentationsField
                      name={`${BASIC_PATH}.behaviors`}
                      type={ADS_CAMPAIGN_SEARCH_SEGMENTATION_BEHAVIORS_TYPE}
                      mode={"fetching"}
                      groupBy={["path", 0]}
                      platform={platform}
                      adAccountID={platformData?.adAccountID}
                      integrationID={platformData?.integrationID}
                      objective={objective}
                      language={language}
                      fullWidth
                      variant="filled"
                      disabled={isDisabledFields}
                      control={control}
                      errors={errors}
                      rules={{
                        required: {
                          value: false,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                    <ClickableText
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "behaviors" })
                      }
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </CardContent>
                )}
              </Card>
            </Grid>
          )}
        </Grid>
      </Box>

      {/* Audience Preview - Responsive */}
      <Box
        sx={{
          width: isTabletOrMobile || showSlideChat ? "100%" : "400px",
          position: isTabletOrMobile || showSlideChat ? "static" : "sticky",
          top: isTabletOrMobile || showSlideChat ? "auto" : 0,
          alignSelf: "flex-start",
          height: "fit-content",
          overflow: "auto",
          order: isTabletOrMobile || showSlideChat ? 1 : 2,
        }}
      >
        <AudienceEstimatesPreviewTikTok BASIC_PATH={BASIC_PATH} />
      </Box>
    </Box>
  );
};

export default AdGroupTikTokForm;
